module.exports = __webpack_public_path__ + "static/media/Logo 2.9dca786a.png";